// Map of internal attribute names to user-friendly display names
export const attributeDisplayNames = {
    nodeType: 'Block Type',
    level: 'Heading Level',
    blockType: 'Block Category',
    sectionType: 'Section Type',
    context: 'Context'
};

export const sectionHeaders = [
    {
        id: 'title',
        title: 'Title',
        command: 'setHeading',
        defaultEnabled: true,
        attrs: {
            level: 2,
            class: 'section-title',
            sectionType: 'title'
        },
        displayAttributes: ['nodeType', 'level', 'sectionType']
    },
    {
        id: 'cross-reference',
        title: 'Cross-Reference to Related Applications',
        command: 'setHeading',
        defaultEnabled: false,
        attrs: {
            level: 2,
            class: 'section-cross-reference',
            sectionType: 'cross-reference'
        },
        displayAttributes: ['nodeType', 'level', 'sectionType']
    },
    {
        id: 'federally-sponsored',
        title: 'Statement Regarding Federally Sponsored Research or Development',
        command: 'setHeading',
        defaultEnabled: false,
        attrs: {
            level: 2,
            class: 'section-federally-sponsored',
            sectionType: 'federally-sponsored'
        },
        displayAttributes: ['nodeType', 'level', 'sectionType']
    },
    {
        id: 'joint-research',
        title: 'Joint Research Agreement',
        command: 'setHeading',
        defaultEnabled: false,
        attrs: {
            level: 2,
            class: 'section-joint-research',
            sectionType: 'joint-research'
        },
        displayAttributes: ['nodeType', 'level', 'sectionType']
    },
    {
        id: 'sequence',
        title: 'Reference to Sequence Listing',
        command: 'setHeading',
        defaultEnabled: false,
        attrs: {
            level: 2,
            class: 'section-sequence',
            sectionType: 'sequence'
        },
        displayAttributes: ['nodeType', 'level', 'sectionType']
    },
    {
        id: 'field',
        title: 'Field',
        command: 'setHeading',
        defaultEnabled: true,
        attrs: {
            level: 2,
            class: 'section-field',
            sectionType: 'field'
        },
        displayAttributes: ['nodeType', 'level', 'sectionType']
    },
    {
        id: 'background',
        title: 'Background',
        command: 'setHeading',
        defaultEnabled: true,
        attrs: {
            level: 2,
            class: 'section-background',
            sectionType: 'background'
        },
        displayAttributes: ['nodeType', 'level', 'sectionType']
    },
    {
        id: 'summary',
        title: 'Brief Summary',
        command: 'setHeading',
        defaultEnabled: true,
        attrs: {
            level: 2,
            class: 'section-summary',
            sectionType: 'summary'
        },
        displayAttributes: ['nodeType', 'level', 'sectionType']
    },
    {
        id: 'incorporation',
        title: 'Incorporation by Reference',
        command: 'setHeading',
        defaultEnabled: true,
        attrs: {
            level: 2,
            class: 'section-incorporation',
            sectionType: 'incorporation'
        },
        displayAttributes: ['nodeType', 'level', 'sectionType']
    },
    {
        id: 'drawings',
        title: 'Brief Description of Drawings',
        command: 'setHeading',
        defaultEnabled: true,
        attrs: {
            level: 2,
            class: 'section-drawings',
            sectionType: 'drawings'
        },
        displayAttributes: ['nodeType', 'level', 'sectionType']
    },
    {
        id: 'detailed',
        title: 'Detailed Description',
        command: 'setHeading',
        defaultEnabled: true,
        attrs: {
            level: 2,
            class: 'section-detailed',
            sectionType: 'detailed'
        },
        displayAttributes: ['nodeType', 'level', 'sectionType']
    },
    {
        id: 'embodiments',
        title: 'Exemplary Embodiments',
        command: 'setHeading',
        defaultEnabled: true,
        attrs: {
            level: 2,
            class: 'section-embodiments',
            sectionType: 'embodiments'
        },
        displayAttributes: ['nodeType', 'level', 'sectionType']
    },
    {
        id: 'examples',
        title: 'Examples',
        command: 'setHeading',
        defaultEnabled: false,
        attrs: {
            level: 2,
            class: 'section-examples',
            sectionType: 'examples'
        },
        displayAttributes: ['nodeType', 'level', 'sectionType']
    },
    {
        id: 'abstract',
        title: 'Abstract',
        command: 'setHeading',
        defaultEnabled: true,
        attrs: {
            level: 2,
            class: 'section-abstract',
            sectionType: 'abstract'
        },
        displayAttributes: ['nodeType', 'level', 'sectionType']
    }
];

export const blocks = [
    {
        id: 'text',
        title: 'Text',
        description: 'Just start writing with plain text',
        command: 'setParagraph',
        displayAttributes: ['nodeType']
    },
    {
        id: 'section',
        title: 'Section Header',
        description: 'Standard patent section header',
        hasSubmenu: true,
        submenuItems: sectionHeaders
    },
    {
        id: 'subsection',
        title: 'Subsection Header',
        description: 'Organize content within sections',
        command: 'setHeading',
        attrs: { 
            level: 3,
            class: 'subsection'
        },
        displayAttributes: ['nodeType', 'level']
    },
    {
        id: 'subsubsection',
        title: 'Sub-subsection Header',
        description: 'Further organize subsection content',
        command: 'setHeading',
        attrs: { 
            level: 4,
            class: 'subsubsection'
        },
        displayAttributes: ['nodeType', 'level']
    },
    {
        id: 'boilerplate',
        title: 'Boilerplate',
        description: 'Insert a saved boilerplate',
        command: 'setBoilerplate',
        hasSubmenu: true,
        submenuItems: [], 
        dynamicSubmenu: 'boilerplates',
        displayAttributes: ['nodeType', 'blockType']
    }
];

// Helper to get section display name from sectionHeaders (single source of truth)
export function getSectionDisplayName(sectionType) {
    const section = sectionHeaders.find(s => s.id === sectionType);
    if (section) {
        return section.title;
    }
    // Fallback for non-standard sections like 'claims'
    if (sectionType === 'claims') return 'Claims';
    return sectionType;
}

export const contextualBlocks = {
    background: [
        {
            id: 'regenerative-support',
            title: 'Regenerative Support',
            description: 'Add regenerative Background',
            command: 'setParagraph',
            attrs: { 
                class: 'regenerative-support',
                blockType: 'regenerative-support',
                context: 'background'
            },
            displayAttributes: ['nodeType', 'blockType', 'context']
        }
    ],
    summary: [
        {
            id: 'regenerative-overview',
            title: 'Regenerative Overview',
            description: 'Add regenerative overview paragraph (problem + solution)',
            command: 'setParagraph',
            attrs: { 
                class: 'regenerative-support',
                blockType: 'regenerative-support',
                context: 'overview'
            },
            displayAttributes: ['nodeType', 'blockType', 'context']
        },
        {
            id: 'regenerative-support',
            title: 'Regenerative Literal Support',
            description: 'Add regenerative literal support for the Brief Summary',
            command: 'setParagraph',
            attrs: { 
                class: 'regenerative-support',
                blockType: 'regenerative-support',
                context: 'summary'
            },
            displayAttributes: ['nodeType', 'blockType', 'context']
        }
    ],
    embodiments: [
        {
            id: 'regenerative-support',
            title: 'Regenerative Support',
            description: 'Add regenerative literal support for the Embodiments',
            command: 'setParagraph',
            attrs: {
                class: 'regenerative-support',
                blockType: 'regenerative-support',
                context: 'embodiments'
            },
            displayAttributes: ['nodeType', 'blockType', 'context']
        }
    ],
    abstract: [
        {
            id: 'regenerative-support',
            title: 'Regenerative Abstract',
            description: 'Add regenerative abstract content',
            command: 'setParagraph',
            attrs: {
                class: 'regenerative-support',
                blockType: 'regenerative-support',
                context: 'abstract'
            },
            displayAttributes: ['nodeType', 'blockType', 'context']
        }
    ],
    detailed: [] // Removed regenerative support for Detailed Description
};
